import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

export type LogoSize = 'small' | 'large';

@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  standalone: true,
  imports: [CommonModule]  
})
export class LogoComponent {
  @Input() width: number | string = 147;
  @Input() height: number | string = 32;
  @Input() viewBox: string = '0 0 147 32';
  @Input() fill: string = 'none';
  @Input() size: LogoSize = 'small';
}